<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M17 4C17.5523 4 18 4.44772 18 5C18 5.55228 17.5523 6 17 6H11V19C11 19.5523 10.5523 20 10 20C9.44772 20 9 19.5523 9 19V6H3C2.44772 6 2 5.55228 2 5C2 4.44772 2.44772 4 3 4H17ZM13 12C12.4477 12 12 11.5523 12 11C12 10.4477 12.4477 10 13 10H21C21.5523 10 22 10.4477 22 11C22 11.5523 21.5523 12 21 12H18V19C18 19.5523 17.5523 20 17 20C16.4477 20 16 19.5523 16 19V12H13Z"
    fill="currentColor"
  />
</svg>
